// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".include-reviews-button{padding-top:.4em !important}.include-reviews-button .custom-control-label:before,.include-reviews-button .custom-control-label:after{margin-left:.2em !important}.include-reviews-button .custom-control-label{border:0 !important;padding-left:.2em !important}", ""]);
// Exports
module.exports = exports;
